/**
 * audioSfx — ALL synthesized sound effects DISABLED site-wide Apr 30 2026
 * per Lead's iter_62 brief: "remover all sound effects site wide." Only
 * ElevenLabs chain narration + founder-opening voice clone remain audible.
 *
 * Every hook below returns a no-op stub so existing callsites in
 * ChainTimeline.js, StoneTablet.js, EpisodeFrame.js etc. can keep their
 * imports + usage patterns intact without strobing a behavioural change
 * through 20+ files. DO NOT re-add the synthesized chisel taps, screen
 * rattle, tape hiss, deep-time drone, or lock click — Lead removed them
 * permanently.
 */
const NOOP = () => {};
const NOOP_INTENSITY = { start: NOOP, stop: NOOP, setIntensity: NOOP };

export function useChiselSfx() {
  return { tap: NOOP, reset: NOOP };
}

export function useScreenRattleSfx() {
  return NOOP;
}

export function useTapeHiss() {
  return NOOP_INTENSITY;
}

export function useDeepTimeDrone() {
  return NOOP_INTENSITY;
}

export function useLockClick() {
  return NOOP;
}
